import { render, staticRenderFns } from "./grafica.vue?vue&type=template&id=139a35c5&"
import script from "./grafica.vue?vue&type=script&lang=js&"
export * from "./grafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports